import { memo } from 'react';
import { NodeProps } from 'reactflow';
import { WorkflowNodeType } from 'src/pages/Settings/workflows/utils/workflow-definition';
import { WorkflowNodeDisplayData } from 'src/pages/Settings/workflows/utils/workflow-helpers';
import { BaseNode } from './nodes/base-node';
import { ConditionalNode, MenuNode, NextStepsOutput } from './nodes/conditional-node';

const WorkflowNodeRouter = (props: NodeProps<WorkflowNodeDisplayData>) => {
  switch (props.data.nodeType) {
    case WorkflowNodeType.If:
      return <ConditionalNode {...props} />;
    case WorkflowNodeType.GatherMenu:
      return <MenuNode {...props} />;
    default:
      return <BaseNode {...props} footer={<NextStepsOutput nodeId={props.data.nodeId} />} />;
  }
};

WorkflowNodeRouter.displayName = 'WorkflowNodeRouter';

export const WorkflowNode = memo(WorkflowNodeRouter);
